// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"98a6aacb","230":"c137292c","389":"835b66a5","671":"684e2311"}[chunkId] + ".chunk.js";
};